/**
 * 通知状態
 */
export var NotifyStatuses;

(function (NotifyStatuses) {
  /**
   * 未通知
   */
  NotifyStatuses[NotifyStatuses["NotNotified"] = 0] = "NotNotified";
  /**
   * 通知済
   */

  NotifyStatuses[NotifyStatuses["Notified"] = 1] = "Notified";
  /**
   * 要再通知
   */

  NotifyStatuses[NotifyStatuses["ReNotificationRequired"] = 2] = "ReNotificationRequired";
})(NotifyStatuses || (NotifyStatuses = {}));